import { render } from "./MultiTextInput.vue?vue&type=template&id=0cfbbb3b"
import script from "./MultiTextInput.vue?vue&type=script&lang=js"
export * from "./MultiTextInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/MultiTextInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cfbbb3b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cfbbb3b', __exports__)) {
    api.reload('0cfbbb3b', __exports__)
  }
  
  module.hot.accept("./MultiTextInput.vue?vue&type=template&id=0cfbbb3b", () => {
    api.rerender('0cfbbb3b', render)
  })

}


export default __exports__